import type { RouteObject } from 'react-router-dom'
import { Factory, MagnifyingGlassPlus, Package, Tag, TestTube } from '@phosphor-icons/react'
import { ROLES } from '@/auth/roles'
import type { PhoneTileDef } from '@/features/phone/tiles'
import { RunsPage } from './pages/RunsPage'
import { OpenRunPage } from './pages/OpenRunPage'
import { RunPage } from './pages/RunPage'
import { MachineLabelPage } from './pages/MachineLabelPage'
import { IssuePage } from './pages/IssuePage'
import { QcSamplePage } from './pages/QcSamplePage'
import { InvestigatePage } from './pages/InvestigatePage'
import { StoreByScope } from '@/features/store/v1/ByScope'
import { V1ProcessHome } from './v1/Home'
import { V1Investigate } from './v1/Investigate'
import { V1Issue } from './v1/Issue'
import { V1MachineLabel } from './v1/MachineLabel'
import { V1OpenRun } from './v1/Open'
import { V1Run } from './v1/Run'
import { V1QcSample } from './v1/Sample'

/**
 * Process (F6) phone flows at a processing site, mounted under /m: the machine operator's runs,
 * the store keeper's issue to a run, QC samples, machine labels, and the supervisor's
 * investigation of a held run.
 */
export const processRoutes: RouteObject[] = [
  // Seva Mandir V1: the processing boards (./v1).
  { path: 'process', element: <StoreByScope v1={<V1ProcessHome />} full={<RunsPage />} /> },
  { path: 'process/open', element: <StoreByScope v1={<V1OpenRun />} full={<OpenRunPage />} /> },
  { path: 'process/run/:runId', element: <StoreByScope v1={<V1Run />} full={<RunPage />} /> },
  {
    path: 'process/machine-label',
    element: <StoreByScope v1={<V1MachineLabel />} full={<MachineLabelPage />} />,
  },
  { path: 'process/issue', element: <StoreByScope v1={<V1Issue />} full={<IssuePage />} /> },
  {
    path: 'process/qc-sample',
    element: <StoreByScope v1={<V1QcSample />} full={<QcSamplePage />} />,
  },
  {
    path: 'process/investigate',
    element: <StoreByScope v1={<V1Investigate />} full={<InvestigatePage />} />,
  },
]

const OPERATOR = [ROLES.MACHINE_OPERATOR, ROLES.SUPERVISOR]

export const processTiles: PhoneTileDef[] = [
  {
    to: '/m/process',
    title: 'process.runs.title',
    hint: 'process.runs.hint',
    icon: Factory,
    team: 'SITE',
    roles: OPERATOR,
    primary: true,
    needs: 'PROCESS',
  },
  {
    to: '/m/process/issue',
    title: 'process.issue.title',
    hint: 'process.issue.hint',
    icon: Package,
    team: 'SITE',
    roles: [ROLES.STORE_KEEPER, ROLES.SUPERVISOR],
    needs: 'PROCESS',
  },
  {
    to: '/m/process/qc-sample',
    title: 'process.qc.title',
    hint: 'process.qc.hint',
    icon: TestTube,
    team: 'SITE',
    roles: OPERATOR,
    needs: 'PROCESS',
  },
  {
    to: '/m/process/machine-label',
    title: 'process.label.title',
    hint: 'process.label.hint',
    icon: Tag,
    team: 'SITE',
    roles: [...OPERATOR, ROLES.CENTRAL_ADMIN],
    needs: 'PROCESS',
  },
  {
    to: '/m/process/investigate',
    title: 'process.investigate.title',
    hint: 'process.investigate.hint',
    icon: MagnifyingGlassPlus,
    team: 'SITE',
    roles: [ROLES.SUPERVISOR],
    needs: 'PROCESS',
  },
]
